import { List, Record } from 'immutable';

import {
  SIGN_OUT_SUCCESS
} from '../auth';

import {
  FILTER_ROOMS,
  LOAD_ROOMS_SUCCESS,
  UNLOAD_ROOMS_SUCCESS,
  UPDATE_ROOM_SUCCESS,
  SELECT_BUILDING
} from './action-types'


export const RoomBrowseState = new Record({
  buildingSelection: 'Bellingrath Hall',
  filter: '',
  list: new List()
})


export function roomBrowseReducer(state= new RoomBrowseState(), {payload, type}) {
  switch (type) {
    case SELECT_BUILDING:
      return state.set('buildingSelection', payload || 'Belingrath')

    case FILTER_ROOMS:
      return state.set('filter', payload.filterType || '');

    case LOAD_ROOMS_SUCCESS:
      return state.set('list', new List(payload.reverse()));

    case UPDATE_ROOM_SUCCESS:
      return state.merge({
        list: state.list.map(room => {
          return room.key === payload.key ? payload : room
        })
      })

    case UNLOAD_ROOMS_SUCCESS:
      return state.set('list', new List());

    case SIGN_OUT_SUCCESS:
      return new RoomBrowseState();

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/core/room-browse/reducer.js